'use strict';/* global define:false, console */define('modules/core/modules/utils/services/chronos/index',[],function(){'use strict';var units={ms:1,s:1e3,m:60*1e3,h:60*60*1e3,d:24*60*60*1e3,w:7*24*60*60*1e3};function twoDigit(num){if(num>=10){return num;}return'0'+num;}/**
   *
   * Extract date as a specifically formatted string
   * from a String or a Date
   *
   * @param {String|Object} date - String formatted date or Date object
   * @returns {String}           - Date as a string in the format yyyy-mm-dd
   *
   * @tested
   */function extractDate(date){if(!(date instanceof Date)){date=createUTCDate(date);}var yyyy=date.getFullYear();var mm=twoDigit(date.getMonth()+1);var dd=twoDigit(date.getDate());return[yyyy,mm,dd].join('-');}/**
   *
   * Extract date in a milliseconds from a String or a Date
   *
   * @param {String|Object} date - String formatted date or Date object
   * @returns {Number}           - Date as a number of milliseconds
   *
   * @tested
   */function curtailDate(date){if(!(date instanceof Date)){date=createUTCDate(date);}date.setHours(0,0,0,0);return date;}/**
   * Extend and return date in a milliseconds from a String or a Date
   *
   * @param {String|Object} date - String formatted date or Date object
   * @returns {Number}           - Date as a number of milliseconds
   *
   * @tested
   */function extendDate(date){if(!(date instanceof Date)){date=createUTCDate(date);}date.setHours(23,59,59,999);return date;}function parse(input){var result=0;input.toString().replace(/([mshdw]+)/g,'$1 ').split(/\s+/).forEach(function(interval){if(!interval){return;}var value=interval.match(/\d+|\d+e\d+/);var unit=interval.match(/[a-z]+$/);if(!(value&&unit&&unit[0]in units)){return;}result+=+value[0]*units[unit[0]];});return result;}function split(text){text=text.split('T');var obj={date:text[0]};if(text.length>1){var time=text[1].split(':');obj.time=time[0]+':'+time[1];}return obj;}function iso(date,time){var output=new Date(date+'T'+time);return output.toISOString().replace('.000Z','+0000');}function join(obj){return iso(obj.date,obj.time);// return obj.date + 'T' + obj.time + ':00+0000';
}/**
   * Generate UTC date object from
   * the supported formatted string dates
   *
   * @param {String} dateString - String formatted date
   * @returns {Date}            - UTC formatted date object
   *
   * @tested
   */function createUTCDate(dateString){// throw an error if the date is formatted wrong e.g. 14/02/2015
if(!dateString.match(/\d{4}-\d{2}-\d{2}/)){throw new Error('Date is in wrong format!');}var timeZoneSpecDate=new Date(dateString);return new Date(timeZoneSpecDate.getTime()+timeZoneSpecDate.getTimezoneOffset()*60*1000);}function service(){}service.prototype={extractDate:extractDate,curtailDate:curtailDate,extendDate:extendDate,parse:parse,iso:iso,split:split,join:join,createUTCDate:createUTCDate};return service;});
